import axiosCustom from "../../../../utils/axiosInstance";
import { GuestTruckingContSealRequestDto } from "../dtos/GuestTruckingContSealRequestDto";
import { ShipmentTruckingGuestInfoResponseDto } from "../dtos/ShipmentTruckingGuestInfoResponseDto";

const BASE_URL = "/public/shipment-truckings";

export interface UpdateTruckingRouteDto {
  lat: number;
  lng: number;
}

export const shipmentTruckingGuestService = {
  getRoutes: async (shipmentTruckingId: string): Promise<ShipmentTruckingGuestInfoResponseDto> => {
    const { data } = await axiosCustom.get<ShipmentTruckingGuestInfoResponseDto>(`${BASE_URL}/${shipmentTruckingId}/routes`);
    return data;
  },

  updateRoute: async (shipmentTruckingId: string, payload: UpdateTruckingRouteDto): Promise<void> => {
    await axiosCustom.put(`${BASE_URL}/${shipmentTruckingId}/routes`, payload);
  },

  updateContSeal: async (shipmentTruckingId: string, payload: GuestTruckingContSealRequestDto): Promise<void> => {
    await axiosCustom.put(`${BASE_URL}/${shipmentTruckingId}/cont-seal`, payload);
  },
};
